import * as L from "react";
import { forwardRef as r } from "react";
const o = r(function(e, C) {
  return /* @__PURE__ */ L.createElement(
    "svg",
    {
      fill: "none",
      ref: C,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...e
    },
    /* @__PURE__ */ L.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M9.07296 2.73056C10.344 3.13385 10.4309 4.14775 9.89223 5.93148L9.82977 6.13269L9.51926 7.09672L9.45589 7.31367C9.41075 7.46892 9.37896 7.62751 9.36084 7.78782L9.35631 7.87443V8.40893L9.36265 8.65038L9.37351 8.84021L9.38981 8.9863L9.40248 9.05454C9.46313 9.01605 9.53103 8.96444 9.60888 8.89708L9.68945 8.82622L9.77726 8.74311C10.1801 8.35382 10.3684 8.04939 10.5105 7.61548L10.5196 7.58924L10.5304 7.55425L10.7776 6.67069L10.8364 6.47211C10.9903 5.97959 11.185 5.49233 11.4574 4.94645L11.5996 4.66826L11.7462 4.40057C11.9436 4.05415 12.1445 3.75321 12.35 3.49077C13.1874 2.42963 13.9931 2.07533 15.237 2.01235L15.4615 2.0036L15.724 2.0001C17.3155 1.97823 21.4625 5.55881 21.9061 7.53238C22.3732 9.61092 21.0461 13.0209 19.0681 14.9332C17.9138 16.0477 15.9395 17.0608 13.1376 17.9881L12.7502 18.114L12.0966 18.317L11.8277 18.6949C11.71 18.8576 11.5941 19.0142 11.481 19.1647L11.3126 19.386L10.9849 19.8007C9.91668 21.119 9.04309 21.8425 8.30438 21.9772L8.18217 21.9938L8.07354 21.9999C6.57803 22.02 1.97925 17.793 2.00007 16.3662C2.00912 15.6996 2.45995 14.9665 3.24482 14.1135L3.37337 13.9753L3.50282 13.8397L3.77621 13.5668L3.78255 13.5598L7.96853 17.2532L8.05091 17.318C8.23844 17.4475 8.47004 17.503 8.69849 17.4732C8.92693 17.4434 9.13501 17.3305 9.28027 17.1576C9.42554 16.9846 9.49705 16.7646 9.48023 16.5425C9.46341 16.3203 9.35952 16.1127 9.18974 15.962L4.93677 12.2073V12.2003L4.95035 12.0945L4.98023 11.8067L5.03454 11.0981L5.12507 9.65466L5.17939 8.85858L5.21017 8.50341L5.24275 8.19111L5.27897 7.93129L5.34143 7.56649L5.41385 7.2017L5.52429 6.69956L5.63564 6.22716L5.7479 5.78626L5.86287 5.3751L5.98055 4.99281L6.10186 4.63939C6.75999 2.83467 7.59827 2.26342 9.07296 2.73056Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  o as MixedMartialArts
};
